// extracted by mini-css-extract-plugin
module.exports = {"col--center":"Profile_col--center__1q_if","col":"Profile_col__1r2wv"};